// extracted by mini-css-extract-plugin
module.exports = {"searchContainer":"SearchInput_searchContainer__3nkQ-","searchIcon":"SearchInput_searchIcon__3MLu3","inputField":"SearchInput_inputField__362S0"};